/* @flow */
import gql from 'graphql-tag';
import type {FilterGroupType} from '../components/MoreFilters/MoreFilters';

type FilteredCountQueryResults = {
    filterGroups?: FilterGroupType[],
    resultCount: number
};

export type FilteredCountQueryResponseData = {
    results: FilteredCountQueryResults,
    error?: Error,
    loading: boolean
};

const commonSelectionSet = `
    id
    resultCount
    filterGroups {
        groupInfo {
            name
            id
        }
        filters {
            count
            checked
            filter {
                id
                name
                refineByQueryArgument
                description
            }
        }
    }
`;

export const fragments = {
    results: gql`
        fragment FilterCountsResults on Results {
            ${commonSelectionSet}
        }
    `,
    searchResult: gql`
        fragment FilterCountsSearchResult on SearchResult {
            ${commonSelectionSet}
        }
    `
};

const filteredCountQuery = gql`
    query FilterCountQuery($params: ResultsParams) {
        results(params: $params) {
            ...FilterCountsResults
        }
    }
    ${fragments.results}
`;

export default filteredCountQuery;
